import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Loading from '../components/Loading';
import { Box, Tab } from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { toast } from 'react-toastify';
import PaymentSetInformations from '../components/InsertUpdatePaymentSet/PaymentSetInformations';
import SetInstallments from '../components/InsertUpdatePaymentSet/SetInstallments';
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../store/recoil/tenant/atoms';
import paymentApi from '../../common/api/paymentApi';
import useAdminCheck from '../../hooks/useAdminCheck';

export type PaymentSetProps = {
    paymentSetId: number
    paymentSetDesc: string,
    isDefaultSet: boolean,
    status: boolean,
    vpList: any[],
    vp: number,
    isInstallmentApplyToAll: boolean
}

type InstallmentItem = {
    installment: number;
    commissionAmount: number;
    status: boolean;
    isBusiness: boolean;
    isIndividual: boolean;
};

type InstallmentList = {
    installmentList: InstallmentItem[];
    bankBrand: {
        bankId: number;
    };
};

export type InstallmentType = {
    vpId: number;
    vpInstallment: InstallmentList[];
};

const InsertUpdatePaymentSet = () => {

    useAdminCheck();
    let { paymentSetId }: any = useParams();
    const loadActive = paymentSetId > 0;
    const { firmInformations } = useRecoilValue(tenantState);
    const { licenseKey, taxCode } = firmInformations;

    const [formValues, setFormValues] = useState<PaymentSetProps>({
        paymentSetId: 0,
        paymentSetDesc: "",
        isDefaultSet: false,
        status: true,
        vpList: [],
        vp: 0,
        isInstallmentApplyToAll: false
    });
    const [getLoading, setGetLoading] = useState(loadActive);
    const [tabIndex, setTabIndex] = useState('1');
    const [isPaymentSetSaved, setIsPaymentSetSaved] = useState(paymentSetId > 0);
    const [installmentList, setInstallmentList] = useState<InstallmentType[]>([
        {
            vpId: 0,
            vpInstallment: [
                {
                    installmentList: [
                        {
                            installment: 0,
                            commissionAmount: 0,
                            status: false,
                            isBusiness: true,
                            isIndividual: true
                        }
                    ],
                    bankBrand: {
                        bankId: 0,
                    },
                },
            ],
        }
    ]);

    useEffect(() => {
        if (paymentSetId > 1) {
            selectPaymentSetInformation();
        }
    }, [paymentSetId])


    const handleTabChange = (event: any, newValue: any) => {
        if (newValue == "2" && !isPaymentSetSaved) {
            toast.error("Taksit tanımı için önce Ödeme Kuralı tanımlayınız.");
        } else {
            setTabIndex(newValue);
        }
    };

    const selectPaymentSetInformation = async () => {
        const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
        const params = {
            paymentSetId: paymentSetId
        };

        const result = await paymentApi.get("/paymentset/get-paymentset/", params, apiParams);
        if (result.isSuccess) {
            const data = result.data;

            const newInstallmentList: InstallmentType[] = data.setInstalment.map((item: any) => ({
                vpId: item.vpId,
                vpInstallment: [
                    {
                        installmentList: item.installmentInfo.map((installment: any) => ({
                            installment: installment.installment,
                            commissionAmount: installment.commissionAmount,
                            status: installment.status,
                            isBusiness: installment.isBusiness,
                            isIndividual: installment.isIndividual,
                        })),
                        bankBrand: {
                            bankId: item.bankInfo.bankId || 0,
                        },
                    },
                ],
            }));

            setInstallmentList(newInstallmentList);

            let vpList: any[] = data.setInstalment.map((item: any) => item.vpId);

            setFormValues({
                paymentSetId: data.paymentSetId,
                paymentSetDesc: data.setDesc,
                isDefaultSet: data.isDefault,
                status: data.status,
                isInstallmentApplyToAll: data.isInstallmentApplyAll,
                vp: data.setInstalment[0]?.vpId || 0,
                vpList: vpList,
            });
        } else {
            toast.error("Ödeme Kuralı bilgileri alınamadı.");
        }

        setGetLoading(false);
    };

    return (
        getLoading ? (
            <Loading desc={paymentSetId > 0 ? "Ödeme Kuralı yükleniyor" : "Sayfa yükleniyor"} />
        ) : (
            <div className="w-full flex flex-col">
                <div className="px-4 pt-4 flex flex-col justify-start space-y-2">
                    <div className="flex flex-row items-center">
                        <img src={"/icons/payment-sets-dark.svg"} className="h-6 w-6 black" />
                        <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                            {paymentSetId > 0 ? "Ödeme Kuralı Güncelle" : "Ödeme Kuralı Tanımla"}
                        </span>
                    </div>
                </div>

                <div className="flex flex-col items-center justify-center">

                    <Box sx={{ width: '100%', typography: 'body1' }} className="px-4 pb-4">
                        <TabContext value={tabIndex}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleTabChange} aria-label="">
                                    <Tab label="ÖDEME SETİ TANIMLARI" value="1" />
                                    <Tab label="TAKSİT TANIMLARI" value="2" />
                                </TabList>
                            </Box>
                            <TabPanel value="1" className="!p-0 !rounded-md">
                                <PaymentSetInformations
                                    formValues={formValues} setFormValues={setFormValues} setIsPaymentSetSaved={setIsPaymentSetSaved}
                                    setTabIndex={setTabIndex} paymentSetId={paymentSetId}
                                />
                            </TabPanel>
                            <TabPanel value="2" className="!p-0 !rounded-md">
                                <SetInstallments
                                    formValues={formValues} setFormValues={setFormValues} setTabIndex={setTabIndex}
                                    paymentSetId={paymentSetId} installmentList={installmentList} setInstallmentList={setInstallmentList}
                                />
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>
            </div>
        )
    )
}

export default InsertUpdatePaymentSet;